/**
 * Fiyatın altındaki yıldız rozetine tıklayınca sayfanın altındaki yorum bölümüne götürür.
 *
 * Rozet zaten `#judgeme_product_reviews` adresine giden bir bağlantı; ancak Judge.me'nin
 * kendi scripti rozete tıklamayı yakalayıp varsayılan davranışı iptal edebiliyor. Bu yüzden
 * dinleyici yakalama aşamasında (capture) çalışıyor: tıklama Judge.me'ye ulaşmadan önce
 * kaydırmayı biz yapıyoruz.
 */
document.addEventListener(
  'click',
  (event) => {
    const badge = event.target.closest('[data-reviews-jump]');
    if (!badge) return;

    const hedef = document.getElementById('judgeme_product_reviews');
    if (!hedef) return;

    event.preventDefault();
    hedef.scrollIntoView({ behavior: 'smooth', block: 'start' });
  },
  true
);
